<template>

    <div class="form">
        <form action="">
            <h2 class="profile__title">Group Members</h2>

            <p>If you have group members - fill in their information here. Do not duplicate your personal information
                here.</p>

            <GroupMemberForm
                v-for="(member, index) in groupMembers"
                :key="index"
                :member="member"
                :index="index"
                :is-active="index === activeForm"
                @activate="activateForm(index)"
                @remove="deleteForm"
                @save-form="updateChangedMember"
            />


            <div class="form-group mb-5" v-if="groupMembers.length === 0 && isPermission">
                <a
                    href="javascript:void(0)"
                    class="btn btn_primary-outline w-100"
                    @click="addNewMember"
                >Add Group Member</a>
            </div>


            <div class="add-link mb-5">
                <a
                    v-if="isPermission"
                    href="javascript:void(0)"
                    @click="addNewMember"
                >+ Add Another Member</a>
            </div>

            <BaseButtons
                v-if="isPermission"
                :on-save="updateArtistGroupMembers"
                :on-cancel="reloadPage"
            />
        </form>
    </div>
</template>

<script>
import BaseButtons from "../Common/BaseButtons.vue";
import ModalHandler from "../../mixins/ModalHandler";
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import GroupMemberForm from "./GroupMemberForm.vue";
import ArtistService from "../../services/ArtistService";

export default {
    name: 'ArtistGroupMembers',
    components: {GroupMemberForm, BaseButtons},
    mixins: [ModalHandler],
    props: {
        adminType: String
    },
    data() {
        return {
            activeForm: null,

        }
    },
    computed: {
        ...mapState(useArtistStore, {
            groupMembers: 'groupMembers',
            artistId: 'artistId'
        }),
        isPermission() {
            return this.adminType !== 'agent'
        },
    },
    methods: {
        async updateArtistGroupMembers() {
            try {
                await ArtistService.updateArtistGroupInfo(this.artistId, this.groupMembers) ;
                this.$showSuccessMessage('The profile was successfully updated')
            } catch (error) {
                this.$showErrorMessage('The profile has not been updated')
            }
        },
        activateForm(index) {
            this.activeForm = index;
        },
        updateChangedMember({ form, index }) {
            this.groupMembers[index] = { ...this.groupMembers[index], ...form };
            this.closeForm()
        },

        closeForm() {
            this.activeForm = null
        },
        async deleteForm(index, member) {
            this.groupMembers.splice(index, 1)
            if (member.id) {
                try {
                    await ArtistService.deleteGroupMember(member.id) ;
                    this.$showSuccessMessage('The Member was successfully deleted')
                } catch (e) {
                    this.$showErrorMessage('The Member has not been deleted')
                }
            } else {
                this.$showSuccessMessage('The Member was successfully deleted')
            }

        },
        addNewMember() {
            this.groupMembers.push({
                id: null,
                first_name: null,
                last_name: null,
                dob: null,
                birth_place: null,
                cell_phone: null,
                home_phone: null,
                legal_name: null,
                number: null,
                date_of_issue: null,
                date_of_expiry: null,
                nationality: null,
                place_of_issue: null,
                cabins: null,
                passport_photo: null,
                passport_photo_id: null,
                residency_card_photo: null,
                residency_card_photo_id: null,
                visa_photo: null,
                visa_photo_id: null,
            })

            this.activeForm = this.groupMembers.length - 1;
        }
    }
}

</script>


<style scoped>

</style>
